import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-black text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full sm:w-[53%]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:text-[57px] text-[1.5rem] font-[700] leading-[1.1]" }, " Track your shipping with ease. "),
  /*#__PURE__*/_createElementVNode("div", { class: "pt-6" }, " know the location of your shipment at any time just with few clicks. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full sm:w-[42%]" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "sm:text-[36px] text-[1.5rem] pt-9 sm:pt-0" }, " Track your delivery "),
  /*#__PURE__*/_createElementVNode("div", { class: "my-5" }, [
    /*#__PURE__*/_createElementVNode("input", {
      placeholder: "Tracking Code",
      registerValue: "pickupLocation",
      class: "w-full border-[#fff] placeholder-[#fff] pl-5 border bg-transparent h-[56px] rounded-[50px]"
    })
  ]),
  /*#__PURE__*/_createElementVNode("button", { class: "rounded-full text-[#690722] px-10 bg-[#FFD44B] w-[174px] h-[57px] py-2 cursor-pointer font-bold hover:border-white hover:text-white" }, " Track ")
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'flex flex-row mx-auto max-w-7xl px-2 sm:px-6 items-center lg:px-8',
        'pt-[8rem] flex-wrap pb-[6rem] text-center sm:text-left',
        _ctx.mainPage ? 'pt-[11.5rem]' : '',
      ])
    }, _hoisted_4, 2)
  ]))
}